import Formsy from 'formsy-react';
import { Component } from 'react';
import { connect } from 'react-redux';
import Asset from '../global/Asset';
import HrefLang from '../../../../shared/localization/hrefLang';
import FormsyCheckbox from '../global/fields/Checkbox';
import Input from '../global/fields/Input';
import Analytics from '../global/Analytics';
import { restockModals } from '../../mock/globalAPI';

import { getHrefLang } from '../../store/selectors/general.selectors';
import { ModalDto, ProductDto } from '../../types/schema';
import { RootState } from '../../store/store.types';

interface RestockNotificationsWizardProps {
  mobile: boolean;
  // modals?: ModalDto[]; -- doesn't seem to be in use rn
  hrefLang?: HrefLang;
  productDetails: ProductDto;
  onClose: () => void;
}

interface RestockNotificationsWizardState {
  emailCaptured: boolean;
  phoneSelection: boolean;
  confirmed: boolean;
  subscribe: boolean;
  canSubmit: boolean;
  emailModal: ModalDto;
  textModal: ModalDto;
  confirmModal: ModalDto;
  email: string;
}

export class RestockNotificationsWizardClass extends Component<RestockNotificationsWizardProps, RestockNotificationsWizardState> {
  constructor(props: RestockNotificationsWizardProps) {
    super(props);
    this.state = {
      email: '',
      emailCaptured: false,
      phoneSelection: false,
      confirmed: false,
      subscribe: false,
      canSubmit: false,
      ...this.getModals(),
    };
    this.enableButton = this.enableButton.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.renderEmailCapture = this.renderEmailCapture.bind(this);
    this.renderConfirmation = this.renderConfirmation.bind(this);
    this.renderTextCapture = this.renderTextCapture.bind(this);
    this.triggerSubscribe = this.triggerSubscribe.bind(this);
  }

  componentDidMount() {
    this.setState({
      ...this.getModals(),
    });
  }

  getModals() {
    return {
      emailModal: restockModals[0],
      textModal: restockModals[1],
      confirmModal: restockModals[2],
    };
  }

  componentDidUpdate(prevProps: RestockNotificationsWizardProps) {
    if (this.props.productDetails.sku !== prevProps.productDetails.sku) {
      this.setState({
        emailCaptured: false,
        phoneSelection: false,
        confirmed: false,
        ...this.getModals(),
      });
    }
  }

  enableButton() {
    this.setState({
      canSubmit: true,
    });
  }

  disableButton() {
    this.setState({
      canSubmit: false,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  renderConfirmation() {
    const { onClose } = this.props;
    const { confirmModal } = this.state;
    return (
      <>
        <div className="couch-image">
          {(confirmModal.assets && confirmModal.assets[0]) && (
            <Asset asset={confirmModal.assets[0]} />
          )}
        </div>
        <h2>{confirmModal.header}</h2>
        <a onClick={onClose}>{confirmModal.buttonCopy && confirmModal.buttonCopy[0]}</a>
      </>
    );
  }

  renderTextCapture() {
    const { name, sku } = this.props.productDetails;
    const { textModal } = this.state;
    return (
      <>
        <div className="text-image">
          {(textModal.assets && textModal.assets[0]) && (
            <Asset asset={textModal.assets[0]} />
          )}
        </div>
        <h2>{textModal.header}</h2>
        <button
          className="btn sms"
          onClick={() => {
            window.open(`sms:2246287769?&body=Hi Burrow! Let me know when the ${name} (${sku}) is back in stock.`);
            this.setState({ phoneSelection: true });
          }}
        >
          {textModal.buttonCopy && textModal.buttonCopy[0]}
        </button>
        <button
          className="btn decline"
          onClick={() => this.setState({ phoneSelection: true })}
        >{textModal.buttonCopy && textModal.buttonCopy[1]}</button>
        <p className="footnote">{textModal.footnote}</p>
      </>
    );
  }

  triggerSubscribe({ email, subscribe }) {
    const {
      sku,
      category,
      image,
      name,
      url,
      id,
      pricing: { price: { raw } },
    } = this.props.productDetails;

    const { hrefLang = HrefLang.EN_US } = this.props;

    Analytics.enqueue({
      method: 'track',
      params: {
        event: 'Stock Notifications',
        properties: {
          sku,
          email,
          oos_mktgsubscribe: !!subscribe,
          image_url: image,
          value: raw,
          action: 'Subscribed',
          label: 'Subscribed to Stock Notifications',
          url: `/${hrefLang}${url}`,
          category,
          name,
          product_id: id,
        },
      },
      location: Analytics.getLocation(),
    });
    this.setState({ emailCaptured: true });
  }

  renderEmailCapture() {
    const { emailModal } = this.state;
    return (
      <>
        <h2>{emailModal.header}</h2>
        <p className="copy">{emailModal.copy}</p>
        <div className="form-fancy">
          <fieldset>
            <Formsy
              onValidSubmit={this.triggerSubscribe}
              onValid={this.enableButton}
              onInvalid={this.disableButton}
            >
              <div className="form-fancy-wrapper">
                <Input
                  label="Email*"
                  autocapitalize="none"
                  value={this.state.email}
                  name="email"
                  validations="isEmail"
                  validationError="Invalid Email"
                  required
                />
              </div>
              <div className="checkbox-wrapper">
                <FormsyCheckbox
                  id="restock"
                  name="subscribe"
                />
                <span className="small-text">{emailModal.buttonCopy && emailModal.buttonCopy[0]}</span>
              </div>
              <button
                className="btn"
                disabled={!this.state.canSubmit}
                type="submit"
              >
                {emailModal.buttonCopy && emailModal.buttonCopy[1]}
              </button>
            </Formsy>
          </fieldset>
        </div>
        <p className="footnote">{emailModal.footnote}</p>
      </>
    );
  }

  render() {
    const {
      mobile,
    } = this.props;
    if (!this.state.emailCaptured) {
      return this.renderEmailCapture.call(this);
    }
    if (!this.state.phoneSelection && mobile) {
      return this.renderTextCapture.call(this);
    }
    return this.renderConfirmation.call(this);
  }
}

const mapStateToProps = (state: RootState) => ({
  hrefLang: getHrefLang(state),
});

export default connect(mapStateToProps, null)(RestockNotificationsWizardClass);
